import React, { Component } from "react";
import { Label, Input, Button, CustomInput } from "reactstrap";
import HttpClient from "./../../utils/HttpClient";

export default class addIconsBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showIconsBox: this.props.showIconsBox ? this.props.showIconsBox : false,
            iconList: [
                { clName: "ri-mail-send-line" },
                { clName: "ri-share-line" },
                { clName: "ri-menu-2-line" },
                { clName: "ri-dashboard-line" },
                { clName: "ri-user-2-line" },
                { clName: "ri-settings-2-line" },
                { clName: "ri-lock-unlock-line" },
                { clName: "ri-notification-3-line" },
            ],
            icons: this.props.icons ? this.props.icons : [],
            selectedList: [
                { iconName: "", url: "", iconId: "", iconUrl: "", icon_index: 0 },
            ],
            selectedListOptions: { iconName: "", url: "", iconId: "", iconUrl: "" },
            activeIcon: "",
            seletedIcon: {},
            design: this.props.design,
            data: this.props.data ? this.props.data : {},
            activeIndex: this.props.activeIndex ? this.props.activeIndex : 0
        };
    }
    componentDidMount = async () => {
        console.log("props data", this.props.data);
        console.log("props activeIndex", this.props.activeIndex);
        this.state.selectedList =
            this.state.data.user[this.state.activeIndex].icon && this.state.data.user[this.state.activeIndex].icon.length > 0
                ? this.state.data.user[this.state.activeIndex].icon
                : [];
        this.state.icons.map((item, index) => {
            item.select = false;
        });
        this.state.icons.map((iii, idd) => {
            let checkSelect = this.state.selectedList.filter(
                (ite) => ite.iconId == iii.id
            );
            if (checkSelect.length > 0) {
                console.log("iii", iii);
                iii.select = true;
            }
        });
        this.state.selectedList.push({
            iconName: "",
            url: "",
            iconId: "",
            iconUrl: "",
            icon_index: 0,
        });

        this.setState({});
    };
   
    closeModal = () => {
        let sendData = this.state.selectedList.filter(
            (item) => item.iconId != ""
        );
        this.props.callBackIcons(false, this.state.activeIndex);
        this.props.callBackSeleted(sendData,this.state.activeIndex);
        this.setState({ showIconsBox: false });
    };

    getIndex(value, arr, prop) {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i][prop] == value) {
                return i;
            }
        }
        return -1;
    }

    render() {
        return (
            <div
                className={this.state.showIconsBox ? "modal fade show" : "modal fade"}
                id="addIconModal"
                tabIndex={-1}
                role="dialog"
                aria-labelledby="addIconModalLabel"
                style={{ display: this.state.showIconsBox ? "block" : "none" }}
            >
                <div
                    className="modal-dialog"
                    role="document"
                    style={{ marginTop: "5%", maxWidth: "700px" }}
                >
                    <div className="modal-content">
                        <div className="modal-header bg-light">
                            <h5 className="modal-title" id="addIconModalLabel">
                                Add your icons
              </h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={this.closeModal}
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="form">
                                        <h5 className="mb-3">Add icons with URL or Document</h5>

                                        <div className="form-group">
                                            <Label for="icon_name">Icon Name</Label>
                                            <Input
                                                className="form-control"
                                                type="text"
                                                value={
                                                    this.state.selectedList[
                                                        this.state.selectedList.length - 1
                                                    ].iconName
                                                }
                                                id="icon_name"
                                                placeholder="Enter Icon Name..."
                                                onChange={(val) => {
                                                    let lenght = this.state.selectedList.length;
                                                    this.state.selectedList[lenght - 1].iconName =
                                                        val.target.value;
                                                    this.setState({});
                                                }}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <Label for="icon_url">Icon URL (Optional)</Label>
                                            <Input
                                                className="form-control"
                                                type="text"
                                                id="icon_url"
                                                placeholder="Enter Icon URL (if any)..."
                                                value={
                                                    this.state.selectedList[
                                                        this.state.selectedList.length - 1
                                                    ].url
                                                }
                                                onChange={(val) => {
                                                    let lenght = this.state.selectedList.length;
                                                    this.state.selectedList[lenght - 1].url =
                                                        val.target.value;
                                                    this.setState({});
                                                }}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <Label for="icon_url">Document or PDF (Optional)</Label>
                                            <div className="custom-file">
                                                <CustomInput
                                                    type="file"
                                                    className="custom-file-input"
                                                    id="customFile"
                                                />
                                                <Label
                                                    className="custom-file-label"
                                                    htmlFor="customFile"
                                                >
                                                    Choose file
                        </Label>
                                            </div>
                                        </div>

                                        <div className="form-group d-flex flex-wrap">
                                            <h6 className="mb-0 my-auto">Your Selected Icons : </h6>
                                            {this.state.selectedList.length > 1 ? (
                                                <>
                                                    {this.state.selectedList.map((item, index) => {
                                                        if (index == this.state.selectedList.length - 1) {
                                                            return null;
                                                        }
                                                        return (
                                                            <div className="relative mx-1 p-1">
                                                                <img
                                                                    src={item.iconUrl}
                                                                    style={{ height: 40, width: 40 }}
                                                                    key={index}
                                                                />
                                                                {/* <svg xmlns={item.iconUrl} viewBox="0 0 841.9 595.3">
                                  <g fill="#61DAFB">
                                    <path d="M666.3 296.5c0-32.5-40.7-63.3-103.1-82.4 14.4-63.6 8-114.2-20.2-130.4-6.5-3.8-14.1-5.6-22.4-5.6v22.3c4.6 0 8.3.9 11.4 2.6 13.6 7.8 19.5 37.5 14.9 75.7-1.1 9.4-2.9 19.3-5.1 29.4-19.6-4.8-41-8.5-63.5-10.9-13.5-18.5-27.5-35.3-41.6-50 32.6-30.3 63.2-46.9 84-46.9V78c-27.5 0-63.5 19.6-99.9 53.6-36.4-33.8-72.4-53.2-99.9-53.2v22.3c20.7 0 51.4 16.5 84 46.6-14 14.7-28 31.4-41.3 49.9-22.6 2.4-44 6.1-63.6 11-2.3-10-4-19.7-5.2-29-4.7-38.2 1.1-67.9 14.6-75.8 3-1.8 6.9-2.6 11.5-2.6V78.5c-8.4 0-16 1.8-22.6 5.6-28.1 16.2-34.4 66.7-19.9 130.1-62.2 19.2-102.7 49.9-102.7 82.3 0 32.5 40.7 63.3 103.1 82.4-14.4 63.6-8 114.2 20.2 130.4 6.5 3.8 14.1 5.6 22.5 5.6 27.5 0 63.5-19.6 99.9-53.6 36.4 33.8 72.4 53.2 99.9 53.2 8.4 0 16-1.8 22.6-5.6 28.1-16.2 34.4-66.7 19.9-130.1 62-19.1 102.5-49.9 102.5-82.3zm-130.2-66.7c-3.7 12.9-8.3 26.2-13.5 39.5-4.1-8-8.4-16-13.1-24-4.6-8-9.5-15.8-14.4-23.4 14.2 2.1 27.9 4.7 41 7.9zm-45.8 106.5c-7.8 13.5-15.8 26.3-24.1 38.2-14.9 1.3-30 2-45.2 2-15.1 0-30.2-.7-45-1.9-8.3-11.9-16.4-24.6-24.2-38-7.6-13.1-14.5-26.4-20.8-39.8 6.2-13.4 13.2-26.8 20.7-39.9 7.8-13.5 15.8-26.3 24.1-38.2 14.9-1.3 30-2 45.2-2 15.1 0 30.2.7 45 1.9 8.3 11.9 16.4 24.6 24.2 38 7.6 13.1 14.5 26.4 20.8 39.8-6.3 13.4-13.2 26.8-20.7 39.9zm32.3-13c5.4 13.4 10 26.8 13.8 39.8-13.1 3.2-26.9 5.9-41.2 8 4.9-7.7 9.8-15.6 14.4-23.7 4.6-8 8.9-16.1 13-24.1zM421.2 430c-9.3-9.6-18.6-20.3-27.8-32 9 .4 18.2.7 27.5.7 9.4 0 18.7-.2 27.8-.7-9 11.7-18.3 22.4-27.5 32zm-74.4-58.9c-14.2-2.1-27.9-4.7-41-7.9 3.7-12.9 8.3-26.2 13.5-39.5 4.1 8 8.4 16 13.1 24 4.7 8 9.5 15.8 14.4 23.4zM420.7 163c9.3 9.6 18.6 20.3 27.8 32-9-.4-18.2-.7-27.5-.7-9.4 0-18.7.2-27.8.7 9-11.7 18.3-22.4 27.5-32zm-74 58.9c-4.9 7.7-9.8 15.6-14.4 23.7-4.6 8-8.9 16-13 24-5.4-13.4-10-26.8-13.8-39.8 13.1-3.1 26.9-5.8 41.2-7.9zm-90.5 125.2c-35.4-15.1-58.3-34.9-58.3-50.6 0-15.7 22.9-35.6 58.3-50.6 8.6-3.7 18-7 27.7-10.1 5.7 19.6 13.2 40 22.5 60.9-9.2 20.8-16.6 41.1-22.2 60.6-9.9-3.1-19.3-6.5-28-10.2zM310 490c-13.6-7.8-19.5-37.5-14.9-75.7 1.1-9.4 2.9-19.3 5.1-29.4 19.6 4.8 41 8.5 63.5 10.9 13.5 18.5 27.5 35.3 41.6 50-32.6 30.3-63.2 46.9-84 46.9-4.5-.1-8.3-1-11.3-2.7zm237.2-76.2c4.7 38.2-1.1 67.9-14.6 75.8-3 1.8-6.9 2.6-11.5 2.6-20.7 0-51.4-16.5-84-46.6 14-14.7 28-31.4 41.3-49.9 22.6-2.4 44-6.1 63.6-11 2.3 10.1 4.1 19.8 5.2 29.1zm38.5-66.7c-8.6 3.7-18 7-27.7 10.1-5.7-19.6-13.2-40-22.5-60.9 9.2-20.8 16.6-41.1 22.2-60.6 9.9 3.1 19.3 6.5 28.1 10.2 35.4 15.1 58.3 34.9 58.3 50.6-.1 15.7-23 35.6-58.4 50.6zM320.8 78.4z"/>
                                    <circle cx="420.9" cy="296.5" r="45.7"/>
                                    <path d="M520.5 78.1z"/>
                                  </g>
                                </svg> */}
                                                                <button
                                                                    class="dltIcn"
                                                                    onClick={() => {
                                                                        // console.log('item.icon_index',item.icon_index);
                                                                        this.state.selectedList.pop(index);
                                                                        this.state.icons[
                                                                            item.icon_index
                                                                        ].select = false;
                                                                        this.setState({});
                                                                    }}
                                                                >
                                                                    <i class="ri-close-line align-middle"></i>
                                                                </button>
                                                            </div>
                                                        );
                                                    })}
                                                </>
                                            ) : null}
                                            {/* <i className="ri-lock-unlock-line font-size-20 mx-1 my-auto"></i> */}
                                        </div>
                                        <Button
                                            color="primary"
                                            type="button"
                                            className="waves-effect waves-light mr-1"
                                            onClick={() => {
                                                let sendData = this.state.selectedList.filter(
                                                    (item) => item.iconId != ""
                                                );

                                                if (sendData.length != 2) {
                                                    alert("Please Select Atleast 2 Icons.");
                                                } else {
                                                    this.props.callBackIcons(false);
                                                    this.props.callBackSeleted(sendData,this.state.activeIndex);
                                                    this.setState({ showIconsBox: false });
                                                }

                                            }}
                                        >
                                            Submit{" "}
                                            <i className="ri-arrow-right-line align-middle ml-1"></i>
                                        </Button>

                                        <Button
                                            color="secondary"
                                            type="button"
                                            className="waves-effect waves-light mr-1"
                                            onClick={() => {
                                                console.log(
                                                    "this.state.selectedList",
                                                    this.state.selectedList
                                                );
                                                let lenght = this.state.selectedList.length;
                                                if (
                                                    this.state.selectedList[lenght - 1].iconName == ""
                                                ) {
                                                    alert("Please Enter Icon Name");
                                                    return false;
                                                }
                                                if (this.state.activeIcon == "") {
                                                    alert("Please Select Icon");
                                                    return false;
                                                }
                                                var index = this.getIndex(
                                                    this.state.seletedIcon.id,
                                                    this.state.icons,
                                                    "id"
                                                );
                                                this.state.icons[index].select = true;
                                                this.setState({});
                                                let bal = {
                                                    iconName: "",
                                                    url: "",
                                                    iconId: "",
                                                    iconUrl: "",
                                                    icon_index: 0,
                                                };
                                                this.state.selectedList.push(bal);
                                                this.setState({ activeIcon: "" });
                                                this.setState({ seletedIcon: {} });
                                            }}
                                        >
                                            Add More <i className="ri-add-fill align-middle ml-1"></i>
                                        </Button>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="border-0 card rounded-0 bg-white py-1 px-0 h-100">
                                        {/* <button
                      id="addIcon"
                      className="btn btn-sm btn-info customUploadBtn"
                    >
                      <i className="ri-add-fill mr-1" />
                      Add Icons
                      <input type="file" className="upload_input" />
                    </button> */}
                                        <div className="form-group mb-2">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search your icon..."
                                            />
                                        </div>
                                        <div className="d-flex flex-wrap w-100 icons_block justify-content-center relative">
                                            {this.state.icons.map((item, index) => {
                                                return (
                                                    <div
                                                        className="iconsItem"
                                                        key={index}
                                                        style={{
                                                            backgroundColor: item.select
                                                                ? "#1c1f1d"
                                                                : "#f1f5f7",
                                                        }}
                                                    >
                                                        <div className="custom-control custom-checkbox mb-0">
                                                            <input
                                                                type="radio"
                                                                className="custom-control-input"
                                                                id={"CustomCheck" + index}
                                                                name="icon"
                                                                onClick={() => {
                                                                    this.setState({ activeIcon: item.img });
                                                                    let lenght = this.state.selectedList.length;
                                                                    this.state.selectedList[lenght - 1].iconUrl =
                                                                        item.img;
                                                                    this.state.selectedList[lenght - 1].iconId =
                                                                        item.id;
                                                                    this.state.selectedList[
                                                                        lenght - 1
                                                                    ].icon_index = index;
                                                                    this.setState({ seletedIcon: item });
                                                                }}
                                                                disabled={item.select ? true : false}
                                                            />
                                                            <label
                                                                className="custom-control-label"
                                                                htmlFor={"CustomCheck" + index}
                                                            >
                                                                <img
                                                                    src={item.img}
                                                                    style={{ height: 40, width: 30 }}
                                                                />

                                                                <i className={`grav_icon ${item.clName}`} />
                                                            </label>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
